
bq.onepagePayment = function (element, options) {
    this.options = options;
    this.$element = $(element);
};

bq.onepagePayment.DEFAULTS = {
    url: '',
    request: {},
    domain: ''
};

bq.onepagePayment.prototype = {
    init: function () {
        this.$element.empty();

        var iframe = $('<iframe/>', {
            name: 'onepage-payment-iframe-' + Math.floor((Math.random() * 99999) + 90000),
            class: 'onepage-payment-iframe',
            title: 'Onepage Payment'
        });
        var form = $('<form/>', {
            action: this.options.url,
            target: iframe.attr('name'),
            method: 'post'
        });
        var input = $('<input/>', {
            type: 'hidden',
            name: 'RequestTokens',
            value: JSON.stringify(this.options.request)
        });

        form.append(input);
        this.$element.append(form);
        this.$element.append(iframe);
        form.submit();

        var proxy = new Porthole.WindowProxy(this.options.domain + 'proxy.html', iframe.attr('name'));
        proxy.addEventListener(function (e) {
            if (e.data['callbacksuccess']) {
                this._catchProxySuccess(e.data['transaction']);
            } else if (e.data['callbackcancel']) {
                this._catchProxyCancel(e.data['transaction']);
            }
        }.bind(this));
    },

    _catchProxySuccess: function (transation) {
        bq.helper.throwEvent('bq.viewhandler.progressmessage', this.$element, {
            message: this.options.viewHandlerMessage
        });

        $.ajax({
            type: 'post',
            url: this.options.submitUrl,
            data: transation,
            success: function (response) {
                var json = JSON.parse(response);
                if (json['forward']) {
                    setLocation(json['forward']);
                } else {
	                  bq.helper.throwEvent('bq.viewhandler.stop', this.$element);
                    var errors = json['errors'] || [{message: bq.messages.global.generalError}];
                    $.each(errors, function (index, error) {
                        bq.helper.throwEvent('bq.notification', $(document), {
                            id: 'notification_bq-ui-' + index,
                            text: error['message'],
                            type: 'error'
                        });
                    });
                }
            }.bind(this)
        });
    },

    _catchProxyCancel: function (transation) {
        /* @todo: Implement me */
    }
};

$.fn.onepagePayment = function (option) {
    return this.each(function () {
        var $this = $(this);
        var data = $this.data('bq.onepagePayment');
        if (!data) {
            var options = $.extend({}, bq.onepagePayment.DEFAULTS, $this.data(), typeof (option) === 'object' && option);
            $this.data('bq.onepagePayment', (data = new bq.onepagePayment(this, options)));
        }
        data.init();
    });
};

$.fn.onepagePayment.Constructor = bq.onepagePayment;

bq.onepagePaymentInit = function () {
    $('[data-onepage-payment-init]').each(function () {
        var el = $(this);
        if (el.data('bq.onepagePayment')) {
            return;
        }
        el.onepagePayment(el.data());
    });
};

bq.init.push(bq.onepagePaymentInit);
